module.exports = __webpack_public_path__ + "img/pay01.83c5627a.png";